module.exports = "<modal>\n\n    widget settings\n\n</modal>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/modals/add-widget-modal/add-widget.modal.html
// module id = ./libs/chassis-core/src/app/dashboards/modals/add-widget-modal/add-widget.modal.html
// module chunks = main